<template lang='pug'>
.full-page
	.main-body

		slot(name='main-body')

	.page(ref='cardPage')
		.toggle-wrapper
			.toggle(v-if='tabs')
				.option(v-for='( name, key ) in tabs' :class='{ active : tab === key }' @click='tab = key') {{ name }}

		.main(
			v-for='( name, key ) in tabs'

			v-if='tab === key'
		)
			slot(:name='`tab-${key}`')

		.main(v-if='!tabs')
			slot(name='default')

</template>

<script>
export default {

	props : {
		tabs : {
			type : Object,
		},
	},

	data : () => ( {
		tab : '',
	} ),

	created() {
		const { tabs } = this;

		if ( tabs ) {
			// eslint-disable-next-line no-unused-vars
			let keys;
			[this.tab, ...keys] = Object.keys( tabs );
		}
	},

	watch : {

		tab : {
			immediate : false,
			handler() {
				this.$emit( 'active-tab', this.tab );
			}
		},

	},
};
</script>

<style lang='scss'>
@import '@/assets/scss/_variables.scss';

.full-page {

	.main-body {
		padding: 0;
		background: white;
		z-index: 3;
		position: relative;

		h1 {
			margin-bottom: 15px;
		}
	}

	.page {
		background-color: white;

		.toggle-wrapper {
			width: 100%;
			overflow: auto;

			.toggle {
				background-color: white;
				position: relative;
				z-index: 2;
				display: flex;
				flex-flow: row nowrap;
				justify-content: space-evenly;
				align-items: center;
				width: fit-content;
				padding: 15px 30px;
				cursor: pointer;

				.option {
					color: $color-secondary;
					text-transform: capitalize;
					font-size: 14px;
					font-weight: 500;
					padding: 5px 15px;
					border: 2px solid transparent;
					border-radius: 30px;

					+ .option {
						margin-left: 10px;
					}

					&.active {
						color: $color-primary;
						border: 2px solid $color-primary;
					}

					&:not(.active):hover {
						background: $lightGrey;
					}
				}
			}
		}

		.main {
			background-color: white;
			min-height: calc(100vh - 27px);
			padding-bottom: 110px;
		}
	}
}

@media only screen and ( max-width: 640px ) {
	.full-page {

		.page {

			.toggle-wrapper {

				.toggle {

					.option + .option {
						margin-left: 0;
					}
				}
			}
		}
	}
}
</style>
